'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true,
});
exports.xDomain = xDomain;

var _d3Interop = require('./d3Interop');

function xDomain(props, stack, horizonal) {
  var data = props.data,
    chartSeries = props.chartSeries,
    x = props.x,
    xScale = props.xScale,
    xDomainProp = props.xDomain;

  if (xDomainProp) return xDomainProp;

  if (!horizonal) {
    if (xScale === 'ordinal') {
      return data.map(function (d) {
        return x(d);
      });
    }
    return _d3Interop.d3Array.extent(data, function (d) {
      return x(d);
    });
  }

  if (stack) {
    var max = 0;
    var min = 0;

    data.forEach(function (d) {
      var totalTop = 0;
      var totalBottom = 0;

      chartSeries.forEach(function (sd) {
        var field = sd.field;

        if (d[field] > 0) {
          totalTop += x(d[field]);
        } else if (d[field] < 0) {
          totalBottom += x(d[field]);
        }
      });

      if (totalTop > max) max = totalTop;
      if (totalBottom < min) min = totalBottom;
    });

    return [min, max];
  }

  var domainArr = chartSeries.map(function (d) {
    var field = d.field;
    return _d3Interop.d3Array.extent(data, function (dt) {
      return x(dt[field]);
    });
  });

  return _d3Interop.d3Array.extent([].concat.apply([], domainArr));
}
